import script from "./FinancialFitnessLandingPage.vue?vue&type=script&setup=true&lang=ts"
export * from "./FinancialFitnessLandingPage.vue?vue&type=script&setup=true&lang=ts"

import "./FinancialFitnessLandingPage.vue?vue&type=style&index=0&id=a65fa904&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-a65fa904"]])

export default __exports__